export const LOCAL_STORAGE_TEMPORARY_BUCKET = 'temporary_bucket';
export const FOLDER_TYPE_TEMPORARY_BUCKET = 'temporary_bucket';

export const LOCAL_STORAGE_SHOW_EMPTY = 'show_empty_folders';
export const LOCAL_STORAGE_PREVIOUS_SEARCHES = 'previous_searches';
export const LOCAL_STORAGE_FAV_DOCS_RESET_KEY =
  'favourite-documents-reset-workaround';
export const LOCAL_STORAGE_RECENTLY_DOCS_RESET_KEY =
  'recently-documents-reset-workaround';
export const LOCAL_STORAGE_TITLE_FULLTEXT_SEARCHES = 'title_fulltext_searches';

export const PASSO_MODULE_CODE = 'PASSO';
export const DIGITAL_ARCHIVE_MODULE_CODE = 'LCA';
export const COSEC_MODULE_CODE = 'COSEC';
export const OPEA_DMS_MODULE_CODE = 'OPEAC';

export const OPEA_DMS_PROJECTNAME_VALUESET = 'opeac_projectname';

export const DOWNLOAD_WARNING_THRESHOLD_MB = 100; // 100 MB

export const LCA_ALLOWED_EXTENSIONS = ['pdf', 'docx'];
